import React, { Component } from 'react';

import TeamForm from './components/TeamForm/TeamForm';
import './TeamManagementPage.scss';

export class TeamManagementPage extends Component {
    render() {
        const { match } = this.props;
        const isCreateNewTeam = match.params.teamId === undefined;

        return (
            <div className="TeamManagementPage">
	            <h2>{isCreateNewTeam ? 'Create New Team' : 'Edit Team'}</h2>
	            <TeamForm/>
            </div>
        );
    }
}

export default TeamManagementPage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/TeamManagementPage/TeamManagementPage.js